(function () {
  'use strict';

  function bindTrigger(btn) {
    btn.addEventListener('click', function () {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (!answer) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        requestAnimationFrame(function () {
          answer.style.maxHeight = '0px';
        });
        btn.setAttribute('aria-expanded', 'false');
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        answer.addEventListener('transitionend', function clearOnOpen(e) {
          if (e.propertyName !== 'max-height') return;
          if (btn.getAttribute('aria-expanded') === 'true') {
            answer.style.maxHeight = 'none';
          }
          answer.removeEventListener('transitionend', clearOnOpen);
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.trypooh-accordion__trigger').forEach(function (btn) {
      var answer = document.getElementById(btn.getAttribute('aria-controls'));
      if (answer && btn.getAttribute('aria-expanded') === 'true') {
        answer.style.maxHeight = 'none';
      }
      bindTrigger(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
